module.exports = __webpack_public_path__ + "static/media/jun3.7e26d2f0.jpg";